export default __webpack_public_path__ + "static/cafe-kraken-hero-14e43186138d4d41a4a62042615e1edc.mp4";